/**
 * SFN i18n — 简体中文 (zh-CN). Overlays EN base with professional translations
 * for every REQUIRED_I18N_KEYS entry.
 */
import type { Dict } from "./types";
import { en } from "./en";

export const zh: Dict = {
  ...en,

  // Navigation
  "nav.home": "首页",
  "nav.about": "关于",
  "nav.contact": "联系",
  "nav.ecosystem": "生态",
  "nav.tokens": "代币",
  "nav.protection": "保障",
  "nav.secure": "认购",
  "nav.faq": "常见问题",
  "nav.connectWallet": "连接钱包",
  "nav.language": "语言",

  // Hero
  "hero.eyebrow": "经验证的 $1 通胀保护 · Solana",
  "hero.stat1": "已保障餐食",
  "hero.stat2": "真实资产背书",
  "hero.stat3": "平均结算",

  // Bento
  "bento.title": "可持续食品与生态网络(SFN):运作原理",
  "bento.sub": "代币经济、实际效用与韧性——如品鉴菜单般精心编排。",
  "bento.card1.title": "愿景与网络(SFN)",
  "bento.card1.text":
    "SFN 是一个由认证合作厨房、本地农户与支持者组成的开放去中心化网络。通过融合社区资金与太阳能运营,我们将食品生产成本压至极低并保持稳定。",
  "bento.card2.title": "去中心化区域采购中心",
  "bento.card2.text":
    "我们的旗舰运营是一个真实的实验场,每天验证 30 泰铢餐食框架。以此为枢纽,我们统一大宗采购、太阳能厨房基础设施及所有合作门店共同遵循的运营标准。",
  "bento.card3.title": "可扩展的全球影响力",
  "bento.card3.text":
    "我们不会止步于一家厨房。SFN 为增长而生。国际支持者可数字化赞助餐食,传统本地小吃店亦可加入网络,获得补贴食材与太阳能。",

  // Pilot / Sandbox
  "pilot.eyebrow": "实时试点概念验证：Thailand Sandbox",
  "pilot.title": "泰国:第一阶段试点市场(沙盒区)",
  "pilot.body":
    "在高效率区域市场内启动,让我们可在最大运营掌控下压力测试 MEAL4 / MEAL2 代币模型与真实供应链。每一间厨房、每一条食材流、每一笔结算,都会在受控环境中完成验证,再启动 SFN 的国际化扩张。",
  "pilot.benchmark.label": "$1 全球基准",
  "pilot.benchmark.value": "$1",
  "pilot.benchmark.desc": "我们将餐价锚定在 30 THB（$1）或以下，通过本地化 Web3 机制证明全球可扩展性。",
  "pilot.phase1": "第一阶段：区域试点（$1 目标）",
  "pilot.phase2": "第二阶段:全球扩张",
  "pilot.phase.arrow": "路线图路径",
  "pilot.stat1.label": "试点市场",
  "pilot.stat1.value": "泰国 · 考幼",
  "pilot.stat2.label": "餐食锚点",
  "pilot.stat2.value": "$1",
  "pilot.stat3.label": "下一阶段",
  "pilot.stat3.value": "全球部署",

  // About
  "about.eyebrow": "创始团队与使命",
  "about.titleA": "关于",
  "about.titleB": "可持续食品与生态网络",
  "about.body":
    "SFN 由一支融合德国经典商业管理与泰国实体餐饮经验的创业团队创立。目睹全球通胀对本地社区的直接冲击,我们决定将区块链技术用于人类基本的稳定生活,而非投机。位于泰国佛丕府的试点厨房,正是这一透明、太阳能驱动、去中心化食品保障未来的运营蓝本。",

  // Contact
  "contact.eyebrow": "合作洽询",
  "contact.titleA": "加入",
  "contact.titleB": "网络",
  "contact.body":
    "无论您是希望接受 MEAL 代币的本地厨房、想直接供货的农户,还是有疑问的国际支持者,请随时联系我们。",
  "contact.name": "姓名",
  "contact.namePh": "您的姓名",
  "contact.email": "邮箱",
  "contact.emailPh": "you@example.com",
  "contact.subject": "主题",
  "contact.subjectPh": "合作、供货、支持……",
  "contact.message": "留言",
  "contact.messagePh": "请介绍您的项目或问题……",
  "contact.sent": "消息已安全送达",
  "contact.successBody": "您的消息已通过加密通道送达。团队成员将在 48 小时内与您联系。",
  "contact.errorTitle": "发送失败",
  "contact.errorBody": "无法送达您的消息,请检查网络后重试。",
  "contact.dismissOk": "再发一条",
  "contact.dismissError": "重试",
  "contact.responseNote": "我们通常在 48 小时内回复。",
  "contact.send": "发送消息",

  // Dual-token
  "dual.eyebrow": "双代币架构",
  "dual.title": "双代币体系:保障与效用并重",
  "dual.sub": "MEAL4 传递价值,MEAL2 稳定价值。二者结合,让食品保障可以真正被消费。",
  "dual.meal4.t": "MEAL4 – 通胀护盾",
  "dual.meal4.d":
    "严格限定总量 100 万枚且永不增发。MEAL4 是由实物资产储备与战略批发采购力背书的数字合约,从源头冻结食品生产成本,构建对抗市场通胀的通缩护盾。",
  "dual.meal2.t": "MEAL2 – 日常效用",
  "dual.meal2.d":
    "面向餐厅日常运营、奖励与社区援助的实用型代币。MEAL2 通过即时移动支付、本地食客的忠诚折扣以及全球支持者的透明数字餐食赞助,驱动整个生态运转。",

  // Protection
  "protection.eyebrow": "不可篡改安全 · 链上执行",
  "protection.title": "写入代码的不可撤销信任",
  "protection.sub":
    "我们将严格的安全参数硬编码进智能合约,保护社区免受通胀与未授权变更的侵害。",
  "protection.f1.title": "100% 防冻结资产",
  "protection.f1.text":
    "两种代币的“冻结权限”均已永久撤销。任何中心方、机构或开发者都无法冻结您的钱包或阻止您使用 MEAL 代币。",
  "protection.f2.title": "硬编码供应上限(MEAL4)",
  "protection.f2.text":
    "MEAL4 的“增发权限”已被不可逆销毁。永远无法再铸造超过 100 万枚 MEAL4,从数学上保护您的食品保障对冲不被稀释。",
  "protection.f3.title": "灵活的效用增长(MEAL2)",
  "protection.f3.text":
    "我们有意保留 MEAL2 的增发能力,以便无缝对接新加入 SFN 网络的合作厨房,确保本地经济始终拥有充足的交易燃料。",

  // Swap
  "swap.eyebrow": "代币发行",
  "swap.title": "锁定您的餐食",
  "swap.sub":
    "直接兑换 MEAL4。每枚代币代表在我们合作厨房中的一份餐食保障——今天、明天,乃至任何危机之后。",
  "swap.connectWallet": "连接钱包以兑换",
  "swap.meal4.milestoneLabel":
    "当前里程碑：第一阶段目标 — Thailand Sandbox 中央厨房基础设施及首批快捷网点扩张",
  "swap.meal4.milestoneProgress": "已募集 {raised} / {goal} USDC",
  "swap.meal4.percent": "已完成 {pct}%",
  "swap.meal4.treasuryLabel": "项目金库钱包",
  "swap.meal4.treasuryNote":
    "所有出资直接进入 SFN 项目金库——无 DEX、无公开市场路由。",
  "swap.meal4.tooltip":
    "代币分配由实物库存直接支撑,并按里程碑资金阶段管理,以确保价格稳定。",
  "swap.meal4.tooltipAria": "了解里程碑资金机制",
  "swap.meal2.rateLabel": "锁定汇率 · 1 USDC = 1 MEAL2",
  "swap.meal2.payWith": "支付方式",
  "swap.meal2.solRoute": "自动路由：SOL → USD（Jupiter）→ MEAL2，每单位 1 美元",
  "swap.meal2.priceFallback": "参考价格（行情离线）",
  "swap.phantomApproving": "等待 Phantom 授权……",

  // Trust
  "trust.eyebrow": "透明与信任",
  "trust.title": "由触手可及的实物支撑。",
  "trust.body":
    "生态由实物资产锚定:泰国合作餐厅“SFN 试点厨房”、配套不动产,以及每天真正上菜的运营厨房。我们公开区域与运营信息——出于团队与客人的安全,精确地址不予公示。",

  // FAQ
  "faq.eyebrow": "常见问题",
  "faq.title": "常见问题解答",
  "faq.sub": "关于可持续食品与生态网络(SFN)与我们的餐食稳定生态,您需要知道的一切。",
  "faq.q1": "在通胀之下,你们如何保证 $1的高质量健康餐?",
  "faq.a1":
    "通过三大支柱:向本地农户直接进行战略性大宗采购、以太阳能基础设施降低餐厅运营成本,以及 MEAL4 通胀护盾的社区背书。这让厨房底价与市场通胀完全脱钩。",
  "faq.q2": "如果代币规模扩大,一家餐厅能满足需求吗?",
  "faq.a2":
    "无需一家承担。“SFN 试点厨房”是我们真实运作的概念验证,总体架构则是 SFN(可持续食品与生态网络)。随着需求增长,独立本地厨房与小吃店可加入网络,共享补贴食材与基础设施,将 30 泰铢的餐食承诺推向全球。",
  "faq.q3": "不居住在泰国的国际支持者如何参与?",
  "faq.a3":
    "全球支持者可购买 MEAL2 代币启动数字化“餐食赞助”。这些代币透明地分配给本地社会援助项目,让长者、低收入家庭或弱势群体在任一 SFN 认证厨房免费或以 30 泰铢享用餐食。",
  "faq.q4": "MEAL4 与普通加密货币有何不同?",
  "faq.a4":
    "MEAL4 并非投机代币,而是由实物食品储备与可持续餐饮基础设施扩张所背书的实用合约。由于增发权限被永久销毁,它是一枚在数学上封顶、面向食品保障的价值存储工具。",

  // Roadmap
  "roadmap.eyebrow": "执行 · 演进",
  "roadmap.title": "从工厂车间到全球协议",
  "roadmap.sub": "六个阶段的真实迭代史。每一个里程碑都源于运营现实,而非幻灯片。",
  "roadmap.card1.title": "工厂工人食品供应",
  "roadmap.card1.desc":
    "目睹日常餐食通胀突破 45 泰铢,工厂工人与低收入群体正被逐步排除在健康营养之外。",
  "roadmap.card2.title": "$1框架构想",
  "roadmap.card2.desc":
    "构建以 30 泰铢稳定利润率为目标的核心经济框架——这是永久平价高质量餐食的基石。",
  "roadmap.card3.title": "供应链源头测试",
  "roadmap.card3.desc":
    "直接对接农户展开采购试点,认清单门店模式的结构性局限,从而确立去中心化区域采购中心的必要性。",
  "roadmap.card4.title": "多分店扩张与太阳能根基",
  "roadmap.card4.desc":
    "扩展至多个分店,识别出一致的能源成本模式,验证太阳能基础设施为缺失的成本稳定层。",
  "roadmap.card5.title": "运营验证与 $1试点",
  "roadmap.card5.desc":
    "整月销售保持绝对稳定——无中月下滑——证明 30 泰铢餐食模型在规模化条件下可持续。",
  "roadmap.card6.title": "SFN 代币化与 SolarPando 冲刺",
  "roadmap.card6.desc":
    "SFN 正式登陆 Solana:MEAL4 与 MEAL2 代币启程、不可篡改性验证,以及 SolarPando 基础设施冲刺同步上线。",

  // Docs
  "docs.eyebrow": "知识库",
  "docs.title": "白皮书与法律文件",
  "docs.sub": "下载官方 SFN 文档与审计报告。",
  "credits.line": "概念与框架由 Boy Khomkrit 创建 — 首次发布：2021 年 7 月 4 日",
  "credits.date": "原始创建日期：2021 年 7 月 4 日（04.07.2021）",
  "credits.version": "白皮书 v1.0 — 首次发布：2021 年 7 月 4 日",
  "docs.btn1": "SFN 生态白皮书 (EN)",
  "docs.btn2": "代币经济执行摘要 (DE)",
  "docs.btn3": "泰国餐饮法律框架",
  "docs.btn4": "加密安全审计报告",

  // Verify
  "verify.meal4.title": "MEAL4 — 通胀护盾验证",
  "verify.meal4.sub": "不可篡改的资产参数",
  "verify.meal4.cta": "在 Solana 浏览器查看 MEAL4",
  "verify.meal2.title": "MEAL2 — 日常效用验证",
  "verify.meal2.sub": "灵活的效用参数",
  "verify.meal2.cta": "在 Solana 浏览器查看 MEAL2",
  "verify.item.meal4Supply.label": "MEAL4 供应上限已验证",
  "verify.item.meal4Supply.statusPassed": "通过 - 上限 1,000,000",
  "verify.item.meal4Supply.statusLive": "通过 - 链上供应量:",
  "verify.item.meal4Mint.label": "MEAL4 增发权限",
  "verify.item.meal4Mint.statusPassed": "通过 - 已销毁(100 万枚硬顶)",
  "verify.item.meal4Mint.statusActive": "启用 - 增发权限存在",
  "verify.item.meal4Freeze.label": "MEAL4 冻结权限",
  "verify.item.meal4Freeze.statusPassed": "通过 - 已撤销(无中心控制)",
  "verify.item.meal4Freeze.statusActive": "启用 - 冻结权限存在",
  "verify.item.meal2Freeze.label": "MEAL2 冻结权限",
  "verify.item.meal2Freeze.statusPassed": "通过 - 已撤销(流动性开放)",
  "verify.item.meal2Freeze.statusActive": "启用 - 冻结权限存在",
  "verify.item.meal2Mint.label": "MEAL2 增发权限",
  "verify.item.meal2Mint.statusRevoked": "已撤销 - 供应冻结",
  "verify.item.meal2Mint.statusActive": "启用 - 由 SFN 增长协议管理",
  "verify.item.meal2Supply.label": "MEAL2 流通供应量",
  "verify.item.meal2Supply.statusLive": "实时 - ",
  "verify.badge.connecting": "连接中",
  "verify.badge.cached": "已缓存",
  "verify.badge.verified": "已验证",
  "verify.networkBusy": "网络繁忙,正在重试连接……(第 ",

  // Transparency
  "transparency.jsonImmutable": "// 不可篡改,无法修改。",
  "transparency.jsonCeiling": "// 硬编码上限。",

  // Connection
  "connection.eyebrow": "// 连接",
  "connection.step1.title": "大宗采购",
  "connection.step1.text":
    "MEAL4 储备资助直接的大批量本地农户采购,将食材成本锁定在市场通胀之下。",
  "connection.step2.title": "太阳能基础设施",
  "connection.step2.text":
    "离网太阳能阵列为合作厨房提供 24/7 电力,消除每份餐食成本中的能源波动。",
  "connection.step3.title": "可兑换餐食",
  "connection.step3.text":
    "客人扫码,以 MEAL2 支付,即可获得一份不到 1 美元的热腾腾营养餐——数字合约在真实餐桌上完成兑现。",

  // Barometer
  "barometer.eyebrow": "实时 · 链上 · 已验证",
  "barometer.title.a": "现实世界",
  "barometer.title.b": "库存晴雨表",
  "barometer.sub":
    "透视支撑每一份餐食的实物储备。数据来自我们的试点厨房——没有臆测,只有库存。",
  "barometer.rice": "大米储备",
  "barometer.oil": "食用油",
  "barometer.solar": "太阳能状态",

  // Footer
  "footer.tag":
    "SFN(可持续食品与生态网络)与 MealToken24 致力于以区块链技术对抗通胀与全球食品不安全。以真实厨房为驱动,为真实的人而建。",
  "footer.disclaimer":
    "免责声明:MEAL2 与 MEAL4 是面向可持续食品与生态网络餐饮生态实用场景的效用型、资产背书社区代币,不构成金融投资或传统证券。",
  "footer.about": "关于",
  "footer.contact": "联系",
  "footer.legal": "法律",
  "footer.rights": "版权所有。",

  // Milestones
  "milestones.eyebrow": "近期路线图:桥接区块链与实体基础设施",
  "milestones.p1.title": "SFN 中央厨房枢纽(考幼)",
  "milestones.p1.desc":
    "由机构资本资助,我们即将建成的自动化中央加工设施将处理大宗食材采购、太阳能冷藏及零浪费餐食制备,在配送前消除中间商成本并保证价格稳定。",
  "milestones.p1.target": "100% 太阳能供应链互联。",
  "milestones.p2.title": "智能快捷门店超速扩张",
  "milestones.p2.desc":
    "将我们经过验证的餐饮框架从旗舰门店扩展到关键高流量走廊上的高效率快捷餐食门店区域网络。每家门店都运行在补贴的零成本能源电网上。",
  "milestones.p2.target": "多地点区域沙盒推行。",

  // VillagePando additions (Phase A)
  "vp.swap.pegged.badge": "1:1 USDC 背书凭证",
  "vp.swap.pegged.tooltip":
    "每一枚 VillagePando 凭证都由 1 枚 USDC 一比一储备背书,可按面值随时赎回。",
  "vp.swap.tax.eyebrow": "5% 太阳能税",
  "vp.swap.tax.title": "5% 税款流向何处?",
  "vp.swap.tax.intro":
    "每笔交易自动扣除的 5% 全部路由至可验证的公共基础设施——绝不作为项目方利润。",
  "vp.swap.tax.total": "税额合计",
  "vp.swap.tax.perTx": "每笔交易",
  "vp.swap.tax.hardware.label": "太阳能硬件基金",
  "vp.swap.tax.hardware.detail":
    "为合作厨房与村庄节点采购离网太阳能板、逆变器与储能设备。",
  "vp.swap.tax.reforestation.label": "再造林与土地",
  "vp.swap.tax.reforestation.detail":
    "资助登记在册地块的原生树种植与土壤修复,链上留痕。",
  "vp.swap.tax.ops.label": "运维与合规",
  "vp.swap.tax.ops.detail":
    "覆盖硬件维护、安装人员培训及跨司法辖区合规成本。",
  "vp.nexus.trio.eyebrow": "// 潘多三元 · 循环流",
  "vp.nexus.trio.caption":
    "土地滋养水。水滋养能源。能源回购餐食。餐食反哺村庄。",
  "vp.nexus.trio.step1": "土地 → 水",
  "vp.nexus.trio.step2": "水 → 能源",
  "vp.nexus.trio.step3": "能源 → 回购餐食",
  "vp.nexus.trio.step4": "餐食 → 村庄",
  "nav.tokenomics": "代币经济",
  "nav.roadmap": "路线图",
  "nav.vision": "愿景",
  "nav.whitepaper": "白皮书",

  // Treasury transparency & purchase receipt
  "treasury.eyebrow": "结算透明度",
  "treasury.title": "每笔 MEAL2 与 MEAL4 购买均结算至同一金库",
  "treasury.desc": "购买不经过任何 DEX 或中转钱包。完整目标地址可在悬停时查看,并在按钮解锁前完成链上验证。",
  "treasury.label": "项目金库",
  "treasury.network": "网络",
  "treasury.copy": "复制地址",
  "treasury.copied": "已复制",
  "treasury.explorer": "在浏览器中查看",
  "treasury.status.checking": "正在验证目标地址",
  "treasury.status.verified": "目标地址已验证",
  "treasury.status.degraded": "地址有效 · 网络繁忙",
  "treasury.status.invalid": "目标地址未验证 — 购买已停用",
  "receipt.eyebrow": "交易已结算",
  "receipt.title": "购买确认",
  "receipt.desc": "您的出资已划入 SFN 项目金库。请保存下方签名作为结算凭证。",
  "receipt.amount": "支付",
  "receipt.received": "获得",
  "receipt.destination": "金库地址",
  "receipt.network": "网络",
  "receipt.hash": "交易签名",
  "receipt.viewExplorer": "在浏览器中查看交易",
  "receipt.close": "关闭确认",
  "receipt.copyHash": "复制哈希",
  "receipt.hashCopied": "已复制哈希",
  "receipt.download": "下载 JSON",
  "rpc.checking": "正在验证网络目标地址…",
  "rpc.degraded": "网络繁忙 — 地址有效，链上校验将在后台重试",
  "rpc.invalid": "目标未验证 — 购买已停用",

  // Analytics consent
  "consent.title": "分析授权",
  "consent.desc": "我们使用匿名、无 Cookie 的产品分析（不记录 IP、不做指纹识别）来改进本页面。在您同意之前不会发送任何数据。",
  "consent.accept": "同意",
  "consent.decline": "拒绝",
  "meal2.tab.web3": "数字兑换（Web3）",
  "hero.title": "锁定粮价：一份优质餐食，永久 $1。",
  "hero.sub": "简单实用。真实基础设施。由 Meal2 与 Meal4 驱动。",
  "hero.badge": "全球首个双代币食品基础设施 —— 以每份 $1 的餐食对冲食品通胀。",
  "hero.cta": "购买 Meal2（$1 一餐）",
  "hero.ghost": "获取 Meal4（治理）",
  "keep.title": "我们如何把餐价保持在 $1",
  "keep.sub": "三类真实资产吸收成本压力，让餐盘价格保持不变。",
  "keep.solar.title": "太阳能",
  "keep.solar.text": "离网太阳能为每间厨房供电，把电费从餐食成本中剔除。",
  "keep.agri.title": "农业",
  "keep.agri.text": "直采农场与造林锁定食材成本，无需中间商。",
  "keep.water.title": "清洁水源",
  "keep.water.text": "过滤水库保障旱季的日常生产，且不产生可变成本。",
  "brand.tagline": "$1 餐食引擎",
  "nav.product": "产品",
  "nav.pilot": "试点厨房",
  "trustpilot.eyebrow": "概念验证 · 试点区域",
  "trustpilot.title": "在泰国验证 —— 面向全球扩张。",
  "trustpilot.desc": "我们的核心厨房与社区枢纽已在日常运营。这里介绍的每一项机制，都会先在真实的餐盘、农户与社区中验证，然后才进行规模化。",
  "trustpilot.b1": "核心厨房每日运营",
  "trustpilot.b2": "区域农户网络",
  "trustpilot.b3": "太阳能社区枢纽",
  "trustpilot.b4": "链上结算已上线",
  "swap.quote.title": "实时路由报价",
  "swap.quote.slippage": "最大滑点",
  "swap.quote.expiry": "报价有效期",
  "swap.quote.minReceive": "最少获得",
  "swap.quote.usdValue": "预计价值",
  "swap.quote.expiresIn": "{s} 秒后刷新",
  "swap.quote.expired": "报价已过期 — 请刷新",
  "swap.quote.refresh": "刷新报价",
  "swap.quote.expiredError": "报价已过期，请刷新汇率后重试。",
  "swap.quote.slippageError": "SOL 汇率已超出您的滑点上限，未进行任何签名。",
  "verify.badge": "购买凭证",
  "verify.title": "验证我的收据",
  "verify.intro": "粘贴您的 Solana 交易签名，即可直接对照网络与 SFN 账本核验购买。验证在服务器端完成，无需连接钱包。",
  "verify.modalIntro": "服务器验证的链上状态及对应账本记录。",
  "verify.label": "交易签名",
  "verify.placeholder": "粘贴您的 Solana 交易签名",
  "verify.submit": "验证收据",
  "verify.busy": "验证中…",
  "verify.close": "关闭收据验证",
  "verify.verified": "链上已验证",
  "verify.unreachable": "网络不可达 — 请稍后重试",
  "verify.notConfirmed": "未确认",
  "verify.invalid": "这不是有效的 Solana 签名。",
  "verify.rateLimited": "查询过于频繁，请稍后再试。",
  "verify.replay": "本次会话中您已查询过该签名。",
  "verify.error": "验证服务繁忙，请稍后再试。",
  "verify.receiptId": "收据编号",
  "verify.signature": "签名",
  "verify.ledgerEntry": "账本记录",
  "verify.purchase": "购买",
  "verify.value": "价值",
  "verify.wallet": "钱包",
  "verify.checks": "结算校验",
  "verify.noLedger": "尚未找到该签名对应的 SFN 账本记录。如果您刚刚支付，请稍等几秒后重试。",
  "verify.explorer": "在 Solscan 查看",
  "admin.csv.export": "下载 CSV",
  "admin.csv.exportLabel": "以 CSV 文件下载销售账本",
  "dexRoadmap.title": "流动性与收录路线图",
  "dexRoadmap.phase1": "预售与实用功能上线",
  "dexRoadmap.phase2": "Jupiter 严格名单与 Raydium 流动性池",
  "dexRoadmap.phase3": "CoinGecko 与 CoinMarketCap 代币收录",
  "dexRoadmap.active": "进行中",
  "dexRoadmap.status.active": "进行中",
  "dexRoadmap.status.next": "下一步",
  "dexRoadmap.status.planned": "计划中",
  "dexRoadmap.statusLive": "路线图阶段状态为实时数据。",
  "dexRoadmap.statusFallback": "实时状态不可用——显示已公布的计划。",
  "dexRoadmap.visit": "在新标签页中打开 {name}",
  "swap.quote.refreshing": "正在刷新汇率…",
};
